export enum PaymentSuspensionStateEnum {
  NotSuspended = 'NotSuspended',
  Staff = 'Staff',
  LifeStatus = 'LifeStatus',
  StaffThenLifeStatus = 'StaffThenLifeStatus'
}
